// extracted by mini-css-extract-plugin
export default {"cls1":"qTOEv3jyTCvc5cVDeXHz","cls2":"KPkSEmTocQ8GOzUWBL8Z qTOEv3jyTCvc5cVDeXHz"};